module.exports = __webpack_public_path__ + "img/icones painel_branco-08.93cbb59f.png";